import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    marginTop: '0px',
    width: '100%',
    boxShadow: 'none',
    // Tabs area should visually belong to the same table,
    // so we don't draw a second border around it.
    border: 'none',
    borderRadius: 0,
    // Keep minimal space between the selected row and the tabs
    paddingTop: '1px',
    paddingBottom: '20px',
    backgroundColor: '#ffffff',
  },
}));


